import { colors, font, devices } from '../../config/theme'
import {
  width100,
  marginPadding0,
  scrollY,
  flexColCenter,
  flexRowCenter,
  flexRowSpaceBetween,
  pointer
} from '../../utils/jss-utils'

const style = {}

style.base = {
  ...width100,
  ...scrollY,
  marginBottom: '30px',
  '& .flip': {
    transform: 'scaleY(-1)',
    filter: 'invert(0) !important'
  },
  '& ul': {
    ...marginPadding0,
    '&> li': {
      ...flexColCenter,
      '&> span': {
        ...flexRowSpaceBetween
      }
    }
  },
  '& svg': {
    width: '17px',
    height: '17px',
    fill: colors.black
  },
  '& li': {
    ...pointer,
    ...flexRowCenter,
    borderTop: `1px solid ${colors.lighterGray}`,
    minHeight: '75px',
    '& span:nth-child(2)': {
      float: 'right',
      ...flexColCenter,
      '& span': {
        color: '#7469FF',
        fontSize: '16px'
      },
      '& img': {
        width: '18px',
        height: '18px',
        marginRight: '18px',
        marginLeft: '18px',
        transition: 'all .3s'
      },
      '&> img': {
        filter: 'invert(.5)'
      }
    }
  },
  '& li:last-child': {
    borderBottom: `1px solid ${colors.lighterGray}`
  }
}

style.paddedIcon = {
  marginLeft: '18px',
  marginRight: '18px'
}

style.subTitle = {
  color: '#808FA9'
}

style.subTitle[devices.desktop] = {
  fontSize: '14px'
}

style.subTitle[devices.mobile] = {
  fontSize: '12px'
}

style.accordian = {
  '& p': {
    fontSize: '14px'
  }
}

style.collapsedDark = {
  backgroundColor: '#f4f4f4'
}

style.accordian[devices.desktop] = {
  padding: '20px 0px 40px 0px',
  width: '50%'
}

style.base[devices.mobile] = {
  marginTop: '0px'
  // '& img': {
  //   filter: 'invert(0) !important'
  // }
}

style.noTopBorder = {}
style.noTopBorder[devices.mobile] = {
  '& li': {
    '&:first-child': {
      borderTop: 'none !important'
    }
  }
}

style.noBorders = {}
style.noBorders[devices.mobile] = {
  '& ul': {
    border: 'none !important',
    borderTop: 'none !important',
    borderBottom: 'none !important'
  },
  '& li': {
    border: 'none !important',
    borderTop: 'none !important',
    borderBottom: 'none !important'
  }
}

style.boldOnMobile = {}
style.boldOnMobile[devices.mobile] = {
  fontWeight: '500'
}

style.reportStyle = {
  '& ul': {
    borderTop: 'none !important'
  },
  '& li': {
    borderBottom: `1px solid ${colors.lighterGray} !important`,
    padding: '0 !important'
  },
  padding: '0 !important',
  '& img': {
    margin: '0 !important',
    marginRight: '25px !important'
  }
}
style.base[devices.desktop] = {
  marginTop: '10px'
}

style.active = {
  color: colors.red
}

style.defaultColor = {
  color: `${colors.black} !important`
}

style.spacer = {
  // sorry this is lazy practice
  marginTop: '21px'
}

style.title = {
  fontSize: '20px'
}

style.title[devices.mobile] = {
  fontSize: '16px'
  // fontWeight: font.weights.medium
}

export default style
